/* eslint-disable no-script-url */

import React from 'react';
import Title from "../Title";
import {withStyles} from "@material-ui/core";
import {mitouStyles} from "../../Helpers/Styles";
import TaskList from "./TaskList";

function Consulting({classes, tasks}) {
    return (
        <React.Fragment>
            <Title className={classes.titleContainer}>Consulting</Title>
            {tasks && (
                <TaskList tasks={tasks} />
            )}
        </React.Fragment>
    );
}

export default withStyles(mitouStyles)(Consulting);
